<div class="files-upload-container flex flex-col">
  <!-- loader element is always invisible -->
  <input #fileUploadButton class="file-input" data-test-id="file-upload-pdf-input" type="file" />
  @if (!file && !converting) {
    <div class="flex flex-col flex-center-start">
      <button
        (click)="fileUploadButton.click()"
        class="add-file-btn"
        color="primary"
        data-test-id="file-upload-addFileBtn"
        mat-button
        type="button"
      >
        Add file
      </button>
    </div>
  }
  @if (converting) {
    <div class="loading-dots">Converting</div>
  }
  @if (file) {
    <file-upload-pdf-element
      [blobUrl]="blobUrl"
      [converting]="converting"
      [file]="file"
      [fileArrayBuffer]="fileArrayBuffer"
      (removeFile)="reset()"
    ></file-upload-pdf-element>
  }
</div>
